// The code in this file will load on every page of your site

$w.onReady(() => {
	waitForLoading();
});

export function button6_onClick() {
	$w('#lightbox1').show();
	waitForLoading();
}

function waitForLoading() {
	setTimeout(() => {
		$w('#lightbox1').hide('FadeOut');
	}, 1500);
}
